"use client";
import {
  __async
} from "../../../chunk-MMUBH76A.js";
import { jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { ExternalWalletProvider } from "../../providers/ExternalWalletContext.js";
import {
  EvmExternalWalletContext,
  EvmExternalWalletProvider
} from "../../providers/EvmExternalWalletContextStub.js";
import { CosmosWallet, EvmWallet, SolanaWallet } from "../../types/externalWallets.js";
import {
  SolanaExternalWalletContext,
  SolanaExternalWalletProvider
} from "../../providers/SolanaExternalWalletContextStub.js";
import {
  CosmosExternalWalletContext,
  CosmosExternalWalletProvider
} from "../../providers/CosmosExternalWalletContextStub.js";
import { useModalStore, useUserInfoStore } from "../../stores/index.js";
import { useExternalWalletProviderStore } from "../../stores/externalWalletProvider/useExternalWalletProviderStore.js";
import { useInternalClient } from "../../../provider/hooks/utils/useInternalClient.js";
const ExternalWalletsWrapper = ({ children, wallets, externalWalletsWithFullAuth }) => {
  const para = useInternalClient();
  const resetModalState = useModalStore((state) => state.resetState);
  const resetUserInfoState = useUserInfoStore((state) => state.resetState);
  const StoredEvmProvider = useExternalWalletProviderStore((state) => state.EvmProvider);
  const storedEvmContext = useExternalWalletProviderStore((state) => state.evmContext);
  const StoredSolanaProvider = useExternalWalletProviderStore((state) => state.SolanaProvider);
  const storedSolanaContext = useExternalWalletProviderStore((state) => state.solanaContext);
  const StoredCosmosProvider = useExternalWalletProviderStore((state) => state.CosmosProvider);
  const storedCosmosContext = useExternalWalletProviderStore((state) => state.cosmosContext);
  const [EvmProvider, setEvmProvider] = useState(null);
  const [evmContext, setEvmContext] = useState(null);
  const [SolanaProvider, setSolanaProvider] = useState(null);
  const [solanaContext, setSolanaContext] = useState(null);
  const [CosmosProvider, setCosmosProvider] = useState(null);
  const [cosmosContext, setCosmosContext] = useState(null);
  useEffect(() => {
    const loadProviders = () => __async(void 0, null, function* () {
      let newEvmContext = EvmExternalWalletContext;
      let newEvmProvider = EvmExternalWalletProvider;
      let newSolanaContext = SolanaExternalWalletContext;
      let newSolanaProvider = SolanaExternalWalletProvider;
      let newCosmosContext = CosmosExternalWalletContext;
      let newCosmosProvider = CosmosExternalWalletProvider;
      if (!(wallets == null ? void 0 : wallets.length)) {
        newEvmContext = EvmExternalWalletContext;
        newEvmProvider = EvmExternalWalletProvider;
        newSolanaContext = SolanaExternalWalletContext;
        newSolanaProvider = SolanaExternalWalletProvider;
        newCosmosContext = CosmosExternalWalletContext;
        newCosmosProvider = CosmosExternalWalletProvider;
      } else {
        for (let i = 0; i < wallets.length; i++) {
          const wallet = wallets[i];
          if (wallet in EvmWallet) {
            if (!StoredEvmProvider || !storedEvmContext) {
              throw new Error("@getpara/evm-wallet-connectors is required to use an external EVM wallet.");
            } else {
              newEvmContext = storedEvmContext;
              newEvmProvider = StoredEvmProvider;
            }
          }
          if (wallet in SolanaWallet) {
            if (!StoredSolanaProvider || !storedSolanaContext) {
              throw new Error("@getpara/solana-wallet-connectors is required to use an external Solana wallet.");
            } else {
              newSolanaContext = storedSolanaContext;
              newSolanaProvider = StoredSolanaProvider;
            }
          }
          if (wallet in CosmosWallet) {
            if (!StoredCosmosProvider || !storedCosmosContext) {
              throw new Error("@getpara/cosmos-wallet-connectors is required to use an external Cosmos wallet.");
            } else {
              newCosmosContext = storedCosmosContext;
              newCosmosProvider = StoredCosmosProvider;
            }
          }
        }
      }
      setEvmContext(newEvmContext);
      setEvmProvider(() => newEvmProvider);
      setSolanaContext(newSolanaContext);
      setSolanaProvider(() => newSolanaProvider);
      setCosmosContext(newCosmosContext);
      setCosmosProvider(() => newCosmosProvider);
    });
    loadProviders();
  }, [
    wallets,
    storedEvmContext,
    StoredEvmProvider,
    storedSolanaContext,
    StoredSolanaProvider,
    storedCosmosContext,
    StoredCosmosProvider
  ]);
  const handleSwitchWallet = ({ address, error }) => {
    if (error || !address) {
      resetModalState();
      resetUserInfoState();
    }
  };
  if (!para || !EvmProvider || !SolanaProvider || !CosmosProvider) {
    return null;
  }
  return /* @__PURE__ */ jsx(EvmProvider, { para, onSwitchWallet: handleSwitchWallet, children: /* @__PURE__ */ jsx(SolanaProvider, { para, onSwitchWallet: handleSwitchWallet, children: /* @__PURE__ */ jsx(CosmosProvider, { para, onSwitchWallet: handleSwitchWallet, children: /* @__PURE__ */ jsx(
    ExternalWalletProvider,
    {
      evmContext,
      solanaContext,
      cosmosContext,
      walletSort: wallets,
      externalWalletsWithFullAuth,
      children
    }
  ) }) }) });
};
export {
  ExternalWalletsWrapper
};
